var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('c-preloader',{attrs:{"isLoading":_vm.isLoading,"bgcolor":"rgba(3,3,3,0.9)"}}):_vm._e(),_c('c-nav'),_c('router-view'),_c('c-footer'),_c('c-notified-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }